import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { PrivateComponent, AppErrorDialogComponent, AppInfoDialogComponent, ConfirmDialogComponent } from './private.component';
import { PrivateRoutingModule } from './private-routing.module';
import { MaterialModule } from '../material.module';


import { BudgetModule } from '../budget';
import { TimereportModule } from '../timereport';
import { DataService } from '../services/data.service';
import { AuthGuard } from '../services/auth-guard.service';
import { OrderModule } from '../order/order.module';
import { InvoicesModule } from '../invoices/invoices.module';
import { DdtModule } from '../ddt/ddt.module';
import { UsersModule } from '../users/users.module';
import { StoreModule } from '../store/store.module';
import { SidebarListComponent, HeaderComponent, NotificationsComponent } from '../components';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ProjectModule } from '../project/project.module';
import { SharedModule } from '../shared/shared.module';
import { InternalProjectModule } from '../internal-project/internal-project.module';
import { LaserCutModule } from '../laser-cut/laser-cut.module';
import { BalancesModule } from '../balances/balances.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    BudgetModule,
    TimereportModule,
    OrderModule,
    InvoicesModule,
    DdtModule,
    UsersModule,
    FlexLayoutModule,
    PrivateRoutingModule,
    ProjectModule,
    InternalProjectModule,
    LaserCutModule,
    BalancesModule,
    StoreModule
  ],
  declarations: [
    PrivateComponent,
    SidebarListComponent,
    HeaderComponent,
    NotificationsComponent,
    AppErrorDialogComponent,
    AppInfoDialogComponent,
    ConfirmDialogComponent
  ],
  providers: [
    DataService,
    AuthGuard,
    DatePipe
  ],
  entryComponents: [
    NotificationsComponent,
    AppErrorDialogComponent,
    AppInfoDialogComponent,
    ConfirmDialogComponent
  ],
})
export class PrivateModule { }



// WEBPACK FOOTER //
// ./src/app/private/private.module.ts